import api from './client'

// Mirror of api/claudeagent.ts for the Codex CLI dispatch path. Same
// session-create + availability-check pair the Claude dock uses, so the
// only difference for the frontend hook is the URL prefix and the agent
// label shown to the user.

//
// The SAME client serves the OpenCode dock: the backend runs one router
// implementation for both engines (codexagent.build_router), mounted at
// /codexagent and /opencodeagent — so the engine is just the URL prefix.

/** A non-Claude CLI dock engine served by the shared router. */
export type CliDockEngine = 'codex' | 'opencode'

export interface CreateCodexAgentSessionPayload {
  project?: string
}

export async function createCodexAgentSession(
  data: CreateCodexAgentSessionPayload = {},
  engine: CliDockEngine = 'codex',
) {
  const res = await api.post(`/${engine}agent/sessions`, data)
  return res.data as { session_id: string }
}

export async function checkCodexAgentAvailability(engine: CliDockEngine = 'codex') {
  const res = await api.get(`/${engine}agent/check-availability`)
  return res.data as { available: boolean; codex_path: string; message: string }
}

export interface CodexAgentSessionState {
  exists: boolean
  running: boolean
}

// Whether a stored codex session id is still alive server-side — used after a
// page refresh to decide between reattaching and creating a new session.
export async function getCodexAgentSessionState(
  sessionId: string,
  engine: CliDockEngine = 'codex',
) {
  const res = await api.get(`/${engine}agent/sessions/${sessionId}/state`)
  return res.data as CodexAgentSessionState
}
